<template>
  <!-- container -->
  <div class="content">

    <!-- 서브 내용 -->
    <div class="container">
      <div class="container-content">

        <div class="terms">

          <TermsNavi></TermsNavi>


          <!-- 서비스 이용약관 -->
          <div class="terms-content">
            <div class="terms-box">
              <h5>제1조 (목적)</h5>
              <p class="terms-description">이 약관은 립페이페이먼츠(이하 '회사'라 한다.)가 제공하는 전자지급결제대행서비스 및 결제대금예치서비스를 이용자가 이용함에 있어 회사와 이용자 사이의 전자금융거래에 관한 기본적인 사항을 정함을 목적으로 합니다.</p>
            </div>
            <div class="terms-box">
              <h5>제2조 (용어의 정의)</h5>
              <p class="terms-description">이 약관에서 정하는 용어의 정의는 다음과 같습니다.</p>
              <ol class="terms-list-nodep">
                <li>'전자금융거래'라 함은 회사가 전자적 장치를 통하여 전자지급결제대행서비스 및 결제대금예치서비스(이하 '전자금융거래 서비스'라고 한다.)를 제공하고, 이용자가 회사의 종사자와 직접 대면하거나 의사소통을 하지 아니하고 자동화된 방식으로 이를 이용하는 거래를 말합니다.</li>
                <li>'전자지급결제대행서비스'라 함은 전자적 방법으로 재화의 구입 또는 용역의 이용에 있어서 지급결제정보를 송신하거나 수신하는 것 또는 그 대가의 정산을 대행하거나 매개하는 서비스를 말합니다.</li>
                <li>'결제대금예치서비스'라 함은 이용자가 재화의 구입 또는 용역의 이용에 있어서 그 대가(이하 '결제대금'이라 한다.)의 전부 또는 일부를 재화 또는 용역(이하 '재화 등'이라 한다.)을 공급받기 전에 미리 지급하는 경우, 회사가 이용자의 물품수령 또는 서비스 이용 확인 시점까지 결제대금을 예치하는 서비스를 말합니다.</li>
                <li>'이용자'라 함은 이 약관에 동의하고 회사가 제공하는 전자금융거래 서비스를 이용하는 자를 말합니다.</li>
                <li>'접근매체'라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적 정보(신용카드번호를 포함한다.), '전자서명법'상의 인증서, 회사에 등록된 이용자번호, 이용자의 생체정보, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등 전자금융거래법 제2조 제10호에서 정하고 있는 것을 말합니다.</li>
                <li>'거래지시'라 함은 이용자가 본 약관에 의하여 체결되는 전자금융거래계약에 따라 회사에 대하여 전자금융거래의 처리를 지시하는 것을 말합니다.</li>
                <li>'오류'라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말합니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제3조 (약관의 명시 및 변경)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 이용자가 전자금융거래 서비스를 이용하기 전에 이 약관을 게시하고 이용자가 이 약관의 중요한 내용을 확인할 수 있도록 합니다.</li>
                <li>회사는 이용자의 요청이 있는 경우 전자문서의 전송방식에 의하여 본 약관의 사본을 이용자에게 교부합니다.</li>
                <li>회사가 약관을 변경하는 때에는 그 시행일 1월 전에 변경되는 약관을 회사가 제공하는 전자금융거래 서비스 이용 초기화면 및 회사의 홈페이지에 게시함으로써 이용자에게 공지합니다. 다만, 법령의 개정으로 인하여 긴급하게 약관을 변경한 때에는 변경된 약관을 홈페이지에 1개월 이상 게시하고 이용자에게 전자우편 등을 통하여 즉시 통보합니다.</li>
                <li>회사는 제3항의 고지나 통지를 할 경우 "이용자가 변경에 동의하지 아니한 경우 고지나 통지를 받은 날로부터 30일 이내에 계약을 해지할 수 있으며, 계약해지의 의사표시를 하지 아니한 경우에는 변경에 동의한 것으로 본다."라는 취지의 내용을 고지하거나 통지합니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5> 제4조 (전자지급결제대행서비스의 종류)</h5>
              <p class="terms-description">회사가 제공하는 전자지급결제대행서비스는 지급결제수단에 따라 다음과 같이 구별됩니다.</p>
              <ol class="terms-list-nodep">
                <li>신용카드결제대행서비스 : 이용자가 결제대금의 지급을 위하여 제공한 지급결제수단이 신용카드인 경우로서, 회사가 전자결제시스템을 통하여 신용카드 지불정보를 송,수신하고 결제대금의 정산을 대행하거나 매개하는 서비스를 말합니다.</li>
                <li>계좌이체대행서비스 : 이용자가 결제대금을 회사의 전자결제시스템을 통하여 금융기관에 등록한 자신의 계좌에서 출금하여 원하는 계좌로 이체할 수 있는 실시간 송금 서비스를 말합니다.</li>
                <li>가상계좌서비스 : 이용자가 결제대금을 현금으로 결제하고자 경우 회사의 전자결제시스템을 통하여 자동으로 이용자만의 고유한 일회용 계좌의 발급을 통하여 결제대금의 지급이 이루어지는 서비스를 말합니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제5조 (결제대금예치서비스의 내용)</h5>
              <ol class="terms-list-nodep">
                <li>이용자(이용자의 동의가 있는 경우에는 재화 등을 공급받을 자를 포함한다. 이하 본 조에서 같다.)는 재화 등을 공급받은 사실을 재화 등을 공급받은 날부터 3영업일 이내에 회사에 통보하여야 합니다.</li>
                <li>회사는 이용자로부터 재화 등을 공급받은 사실을 통보받은 후 회사와 통신판매업자간 사이에서 정한 기일 내에 통신판매업자에게 결제대금을 지급합니다.</li>
                <li>회사는 이용자가 재화 등을 공급받은 날부터 3영업일이 지나도록 정당한 사유의 제시없이 그 공급받은 사실을 회사에 통보하지 아니하는 경우에는 이용자의 동의없이 통신판매업자에게 결제대금을 지급할 수 있습니다.</li>
                <li>회사는 통신판매업자에게 결제대금을 지급하기 전에 이용자에게 결제대금을 환급받을 사유가 발생한 경우에는 그 결제대금을 소비자에게 환급합니다.</li>
                <li>회사는 이용자와의 결제대금예치서비스 이용과 관련된 구체적인 권리, 의무를 정하기 위하여 본 약관과는 별도로 결제대금예치서비스이용약관을 제정할 수 있습니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제6조 (이용시간)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 이용자에게 연중무휴 1일 24시간 전자금융거래 서비스를 제공함을 원칙으로 합니다. 단, 금융기관 기타 결제수단 발행업자의 사정에 따라 달리 정할 수 있습니다.</li>
                <li>회사는 정보통신설비의 보수, 점검 기타 기술상의 필요나 금융기관 기타 결제수단 발행업자의 사정에 의하여 서비스 중단이 불가피한 경우, 서비스 중단 3일 전까지 게시가능한 전자적 수단을 통하여 서비스 중단 사실을 게시한 후 서비스를 일시 중단할 수 있습니다. 다만, 시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 사전 게시없이 서비스를 중단할 수 있습니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제7조 (접근매체의 선정과 사용 및 관리)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 전자금융거래 서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인할 수 있습니다.</li>
                <li>이용자는 접근매체를 사용함에 있어서 다른 법률에 특별한 규정이 없는 한 다음 각 호의 행위를 하여서는 아니됩니다.
                  <ul class="terms-list-dep2">
                    <li><span>가. 접근매체를 양도하거나 양수하는 행위</span></li>
                    <li><span>나. 접근매체를 제3자에게 대여하거나 사용을 위임하는 행위</span></li>
                    <li><span>다. 접근매체를 질권 기타 담보 목적으로 제공하는 행위</span></li>
                    <li><span>라. 1호부터 3호까지의 행위를 알선하는 행위</span></li>
                  </ul>
                </li>
                <li>이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.</li>
                <li>회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제8조 (거래내용의 확인)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 이용자와 미리 약정한 전자적 방법을 통하여 이용자의 거래내용(이용자의 '오류정정 요구사실 및 처리결과에 관한 사항'을 포함한다.)을 확인할 수 있도록 하며, 이용자의 요청이 있는 경우에는 요청을 받은 날로부터 2주 이내에 모사전송 등의 방법으로 거래내용에 관한 서면을 교부합니다. 다만, 전자적 장치의 운영장애, 그 밖의 사유로 거래내용을 제공할 수 없는 때에는 즉시 이용자에게 전자문서 전송(전자우편을 이용한 전송을 포함한다.)의 방법으로 그러한 사유를 알려야 하며, 거래내용을 제공할 수 없는 기간은 서면교부 기간에 산입하지 아니합니다.</li>
                <li>제1항의 대상이 되는 거래 내용 중 대상기간이 5년인 것은 다음 각 호와 같습니다.
                  <ul class="terms-list-dep2">
                    <li><span>가. 거래계좌의 명칭 또는 번호</span></li>
                    <li><span>나. 전자금융거래의 종류 및 금액</span></li>
                    <li><span>다. 전자금융거래상대방을 나타내는 정보</span></li>
                    <li><span>라. 전자금융거래일시</span></li>
                    <li><span>마. 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보</span></li>
                    <li><span>바. 회사가 전자금융거래의 대가로 받은 수수료</span></li>
                    <li><span>사. 이용자의 출금 동의에 관한 사항</span></li>
                    <li><span>아. 해당 전자금융거래와 관련한 전자적 장치의 접속기록</span></li>
                    <li><span>자. 전자금융거래의 신청 및 조건의 변경에 관한 사항</span></li>
                    <li><span>차. 건당 거래금액이 1만원을 초과하는 전자금융거래에 관한 기록</span></li>
                  </ul>
                </li>
                <li>제1항의 대상이 되는 거래내용 중 대상기간이 1년인 것은 다음 각호와 같습니다.
                  <ul class="terms-list-dep2">
                    <li><span>가. 건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록</span></li>
                    <li><span>나. 전자지급수단 이용과 관련된 거래승인에 관한 기록</span></li>
                    <li><span>다. 이용자의 오류정정 요구사실 및 처리결과에 관한 사항</span></li>
                  </ul>
                </li>
                <li>
                  이용자가 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.
                  <ul class="terms-list-nodep manager-info list-dotted">
                    <li>주소 : 경상북도 경산시 둥지로 18길 19, 401호</li>
                    <li>이메일 주소 : reappay@reappay.co.kr</li>
                    <li>전화번호 : 1661-0447</li>
                    <li>FAX : 02-3445-9115</li>
                  </ul>
                </li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제9조 (오류의 정정 등)</h5>
              <ol class="terms-list-nodep">
                <li>이용자는 전자금융거래 서비스를 이용함에 있어 오류가 있음을 안 때에는 회사에 대하여 그 정정을 요구할 수 있습니다.</li>
                <li>회사는 전항의 규정에 따른 오류의 정정요구를 받은 때 또는 스스로 오류가 있음을 안 때에는 이를 즉시 조사하여 처리한 후 정정요구를 받은 날 또는 오류가 있음을 안 날부터 2주 이내에 오류의 원인과 처리결과를 문서, 전화 또는 전자우편으로 이용자에게 알립니다. 다만, 이용자가 문서로 알려줄 것을 요청한 경우에는 문서로 알립니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제10조 (회사의 책임)</h5>
              <ol class="terms-list-nodep">
                <li><span>회사는 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 있습니다. 다만 이용자가 제7조 제2항에 위반하거나 제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 알 수 있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.</span></li>
                <li><span>회사는 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만 본 조 제1항 단서에 해당하거나 법인('중소기업기본법' 제2조 제2항에 의한 소기업을 제외한다.)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.</span></li>
                <li>
                  <span>회사는 전자금융거래를 위한 전자적 장치 또는 ''정보통신망 이용촉진 및 정보보호 등에 관한 법률'' 제2조 제1항제1호에 따른 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 다음과 같은 경우 회사는 이용자에 대하여 일부 또는 전부에 대하여 책임을 지지 아니합니다.</span>
                  <ul class="terms-list-dep2">
                    <li><span>가. 회사가 전자금융거래법 제6조 제1항에 따른 확인 외에 보안강화를 위하여 전자금융거래시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 전자금융거래법 제9조제1항 제3호에 따른 사고가 발생한 경우</span></li>
                    <li><span>나. 이용자가 동항 제 '가'목의 추가적인 보안조치에서 사용되는 매체, 수단 또는 정보에 대하여 다음과 같은 행위를 하여 '사고'가 발생하는 경우</span>
                      <ul class="terms-list-dep3 list-dotted">
                        <li>누설, 누출 또는 방치한 행위</li>
                        <li>3자에게 대여하거나 그 사용을 위임한 행위 또는 양도나 담보의 목적으로 제공한 행위</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제11조 (전자지급거래계약의 효력)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 이용자의 거래지시가 전자지급거래에 관한 경우 그 지급절차를 대행하며, 전자지급거래에 관한 거래지시의 내용을 전송하여 지급이 이루어지도록 합니다.</li>
                <li>회사는 이용자의 전자지급거래에 관한 거래지시에 따라 지급거래가 이루어지지 않은 경우 수령한 자금을 이용자에게 반환하여야 합니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제12조 (거래지시의 철회)</h5>
              <ol class="terms-list-nodep">
                <li>이용자는 전자지급거래에 관한 거래지시의 경우 지급의 효력이 발생하기 전까지 거래지시를 철회할 수 있습니다.</li>
                <li>전항의 지급의 효력이 발생 시점이란 (i) 전자자금이체의 경우에는 거래지시 된 금액의 정보에 대하여 수취인의 계좌가 개설되어 있는 금융기관의 계좌 원장에 입금기록이 끝난 때 (ii) 그 밖의 전자지급수단으로 지급하는 경우에는 거래지시 된 금액의 정보가 수취인의 계좌가 개설되어 있는 금융기관의 전자적 장치에 입력이 끝난 때를 말합니다.</li>
                <li>이용자는 지급의 효력이 발생한 경우에는 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령상 청약의 철회의 방법 또는 본 약관 제5조에서 정한 바에 따라 결제대금을 반환 받을 수 있습니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제13조 (전자지급결제대행 서비스 이용 기록의 생성 및 보존)</h5>
              <ol class="terms-list-nodep">
                <li>회사는 이용자가 전자금융거래의 내용을 추적, 검색하거나 그 내용에 오류가 발생한 경우에 이를 확인하거나 정정할 수 있는 기록을 생성하여 보존합니다.</li>
                <li>전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및 보존방법은 제8조 제2항에서 정한 바에 따릅니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제14조 (전자금융거래정보의 제공금지)</h5>
              <p class="terms-description">회사는 이용자가 안전하게 전자금융거래서비스를 이용할 수 있도록 이용자의 개인정보보호를 위하여 개인정보취급방침을 운용합니다. 회사의 개인정보취급방침은 회사의 홈페이지 또는 서비스 페이지에 링크된 화면에서 확인할 수 있습니다.</p>
            </div>
            <div class="terms-box">
              <h5>제15조 (분쟁처리 및 분쟁조정)</h5>
              <ol class="terms-list-nodep">
                <li>
                  이용자는 회사 홈페이지에 게시된 분쟁처리 책임자 및 담당자 또는 아래 연락처를 통하여 전자금융거래와 관련한 의견 및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할 수 있습니다.
                  <ul class="terms-list-dep3 list-dotted">
                    <li>담당 : 전략부장</li>
                    <li>주소 : 경상북도 경산시 둥지로 18길 19, 401호</li>
                    <li>이메일 주소 : reappay@reappay.co.kr</li>
                    <li>전화번호 : 1661-0447</li>
                    <li>FAX : 02-3445-9115</li>
                  </ul>
                </li>
                <li>이용자가 회사에 대하여 분쟁처리를 신청한 경우에는 회사는 15일 이내에 이에 대한 조사 또는 처리 결과를 이용자에게 안내합니다.</li>
                <li>이용자는 제2항에 따른 회사의 분쟁처리결과에 대하여 이의가 있을 경우에는 금융감독원 금융분쟁조정위원회, 한국소비자원 소비자분쟁조정위원회 등을 통하여 회사의 전자금융거래서비스의 이용과 관련한 분쟁조정을 신청할 수 있습니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>제16조 (회사의 안정성 확보 의무)</h5>
              <p class="terms-description">회사는 전자금융거래가 안전하게 처리될 수 있도록 선량한 관리자로서 주의를 다하며, 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.</p>
            </div>
            <div class="terms-box">
              <h5> 제17조 (약관외 준칙 및 관할)</h5>
              <ol class="terms-list-nodep">
                <li>회사와 이용자 사이에 개별적으로 합의한 사항이 이 약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에 우선하여 적용합니다.</li>
                <li>이 약관에서 정하지 아니한 사항에 대하여는 전자금융거래법, 전자상거래 등에서의 소비자 보호에 관한 법률, 통신판매에 관한 법률, 여신전문금융업법 등 소비자보호 관련 법령에서 정한 바에 따릅니다.</li>
                <li>회사와 이용자간에 발생한 분쟁에 관한 관할은 민사소송법에서 정한 바에 따릅니다.</li>
              </ol>
            </div>
            <div class="terms-box">
              <h5>부칙</h5>
              <ul class="terms-list-nodep">
                <li>최초시행일자 : 2020년 06월 19일</li>
                <li>약관개정일자 : 2022년 07월 29일</li>
              </ul>
            </div>
          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import TermsNavi from "@/pages/terms/components/TermsNavi";
export default {
  name: "UseTermsView",
  components: {
    TermsNavi
  }
}
</script>

<style scoped>

</style>